import { wymhScreens } from "@/mocks/wymh-content";

export default function WymhPreview() {
  return (
    <section id="wymh-preview" className="wymh-anchor w-full bg-foreground-950 pt-20 md:pt-24 pb-16 md:pb-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full wymh-halftone-dark opacity-40"></div>
      <div className="relative w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-accent-400 text-sm font-label font-bold tracking-widest mb-4">
            <i className="ri-smartphone-line w-4 h-4 flex items-center justify-center"></i>
            软件预览
          </span>
          <h2 className="wymh-heading text-background-50 text-4xl md:text-5xl leading-tight mb-4">
            四个界面，看完整套体验
          </h2>
          <p className="text-background-100/70 text-base leading-8">
            从点开图标到翻开最新一话，中间只有几次点击。下面是客户端里最常用的四个界面，先看一遍再决定要不要装。
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {wymhScreens.map((screen) => (
            <div key={screen.tag}>
              <div className="w-full h-[360px] md:h-[520px] rounded-[26px] border-4 border-foreground-800 bg-foreground-900 overflow-hidden mb-4">
                <img
                  src={screen.image}
                  alt={`五一漫画${screen.tag}界面`}
                  title={`五一漫画${screen.tag}`}
                  className="w-full h-full object-top"
                />
              </div>
              <span className="inline-flex px-3 py-1 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-300 text-xs font-medium mb-2">
                {screen.tag}
              </span>
              <h3 className="text-background-50 font-bold text-lg mb-1">{screen.title}</h3>
              <p className="text-background-100/65 text-sm leading-6">{screen.caption}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}